import { animated, useSpring } from "@react-spring/web";
import classNames from "classnames/bind";
import React from "react";
import type { TabIndicatorProps } from "../types";
import styles from "./TabsNavBar.module.scss";

const cx = classNames.bind(styles);

const TabIndicator = ({
  activeTabWidth,
  tabIndicatorLeftPosition,
}: TabIndicatorProps) => {
  const animationStyles = useSpring({
    width: activeTabWidth,
    transform: `translateX(${tabIndicatorLeftPosition}px)`,
    config: { duration: 150 },
  });

  return (
    <animated.div
      style={animationStyles}
      className={cx("indicator")}
      role="presentation"
      data-role="tab-indicator"
    />
  );
};

export default TabIndicator;
